import { stringEnumCodec } from "@every.org/common/src/codecs/index";
import { ClientRouteName } from "@every.org/common/src/helpers/clientRoutes";

/**
 * Tabs displayed on the page. Values are how they are displayed
 */
export enum UserPageTab {
  LISTS = "Lists",
  DONATIONS = "Donations",
  LIKES = "Likes",
  JOINS = "Joins",
  FUNDRAISERS = "Fundraisers",
  FOLLOWING = "Following",
  FOLLOWERS = "Followers",
}

export const USER_ROUTE_NAME_FOR_TAB: {
  [tab in UserPageTab]: ClientRouteName;
} = {
  [UserPageTab.LISTS]: ClientRouteName.USER_LISTS,
  [UserPageTab.DONATIONS]: ClientRouteName.USER_DONATIONS,
  [UserPageTab.LIKES]: ClientRouteName.USER_LIKES,
  [UserPageTab.JOINS]: ClientRouteName.USER_JOINS,
  [UserPageTab.FUNDRAISERS]: ClientRouteName.USER_FUNDRAISERS,
  [UserPageTab.FOLLOWING]: ClientRouteName.USER_FOLLOWING,
  [UserPageTab.FOLLOWERS]: ClientRouteName.USER_FOLLOWERS,
};

export const userTabCodec = stringEnumCodec({
  name: "UserPageTab",
  enumObject: UserPageTab,
});
export const USER_TAB_PARAM = "tab";
